import { Button, CircularProgress, Divider, Grid2, SpeedDial, SpeedDialAction, SpeedDialIcon, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import _ from 'lodash';
import { useContext } from "react";
import { DialogsContext, SessionDataContext } from '../contexts';
import TermCard from "./term.card";
import { termApi } from "./term.queries";
import LoadingIndicator from "../common/loading.indicator";

export default function TermList(props) {
	const useGetAll = termApi.useGetAll();
	let terms = useGetAll?.data;

	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);

	const now = new Date().getTime();
	const activeTerms = _.chain(terms).filter(term => term.startDate <= now && term.endDate >= now).orderBy('startDate').value();
	const upcomingTerms = _.chain(terms).filter(term => term.startDate >= now).orderBy('startDate').value();
	const completedTerms = _.chain(terms).filter(term => term.endDate <= now).orderBy('startDate', 'desc').value();

	if (useGetAll.isPending) {
		return <LoadingIndicator />;
	}

	const renderTermGroup = (label, terms) => {
		const maxScore = _.chain(terms).map('score').max().value();
		return (
			<Box>
				<Divider sx={{ pt: 3, pb: 2 }} textAlign="left">
					<Typography variant="h6">{label} ({terms.length})</Typography>
				</Divider>

				<Grid2 container>
					{terms?.length > 0 &&
						terms?.map(term =>
							<Grid2 size={{ xs: 12, xl: (terms.length == 1 ? 12 : 6) }} key={term.id}>
								<TermCard id={term.id} />
							</Grid2>
						)
					}
					{terms?.length == 0 &&
						<Typography sx={{ p: 8, fontSize: '1.25rem', fontStyle: 'italic', textAlign: 'center', flex: 1, color: 'muted' }}>-- No {label} --</Typography>
					}
				</Grid2>
			</Box>
		);
	};

	if (!terms?.length) {
		return (
			<Box sx={{ p: 2 }}>
				<Typography variant="h2">You don't have any Terms</Typography>
				<Typography variant="h4">Terms are a great way to organize coursework for your terms.</Typography>
				<Button variant="contained" color="primary" onClick={() => dialogs.open('term', {})}>New Term</Button>
			</Box>
		);
	}

	return (
		<Box sx={{ p: 2 }}>
			<Grid2 container spacing={4}>
				<Grid2 size={{ xs: 12 }}>
					{renderTermGroup('Active Terms', activeTerms)}
					{renderTermGroup('Upcoming Terms', upcomingTerms)}
					{renderTermGroup('Completed Terms', completedTerms)}
				</Grid2>
			</Grid2>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>New Term</Typography>} onClick={() => dialogs.open('term', {})} />
			</SpeedDial>
		</Box >
	);
}
